import {
  SCHEMA_VERSION,
  DEFAULT_MAX_SPIRIT,
  DEFAULT_MAX_ACTIVE_CARDS,
  DEFAULT_CARDS_PER_TURN,
  DEFAULT_MAX_EQUIPMENT_SLOTS
} from './StateConstants.js';

const STARTER_DECK = [
  { cardId: 'construction_squad', count: 1, active: 1 },
  { cardId: 'mana_meditation', count: 1, active: 1 },
  { cardId: 'spirit_strike', count: 1, active: 1 },
  { cardId: 'fireball', count: 1, active: 1 },
  { cardId: 'sandbags', count: 1, active: 1 },
  { cardId: 'soldier', count: 1, active: 1 },
  { cardId: 'arcane_insight', count: 1, active: 1 },
  { cardId: 'recon_drone', count: 1, active: 1 },
];

function createStarterSlotConfig() {
  const config = {};
  for (const card of STARTER_DECK) {
    if (card.active > 0) {
      config[card.cardId] = card.active;
    }
  }
  return config;
}

export function createDefaultState() {
  return {
    _meta: {
      schemaVersion: SCHEMA_VERSION,
      lastSaved: null,
      gameVersion: '0.1.0'
    },

    player: {
      username: 'Guest',
      isLoggedIn: false
    },

    resources: {
      spirit: DEFAULT_MAX_SPIRIT,
      maxSpirit: DEFAULT_MAX_SPIRIT
    },

    deck: {
      maxActiveCards: DEFAULT_MAX_ACTIVE_CARDS,
      cardsPerTurn: DEFAULT_CARDS_PER_TURN,
      ownedCards: STARTER_DECK.map(card => ({ ...card })),
      activeDeckSlot: 0,
      deckSlots: [createStarterSlotConfig(), {}, {}, {}, {}]
    },

    equipment: {
      maxActiveSlots: DEFAULT_MAX_EQUIPMENT_SLOTS,
      ownedEquipment: [],
      toggledEquipment: []
    },

    map: {
      seed: Math.floor(Math.random() * 2147483647),
      playerPosition: { q: 0, r: 0 },
      exploredTiles: [{ q: 0, r: 0 }],
      visitedTiles: [{ q: 0, r: 0 }],
      clearedTiles: [{ q: 0, r: 0 }],
      tileRewardBundles: {},
      pendingBattlePosition: null,
      pendingTraderPosition: null,
      pendingStoryNodePosition: null,
      tileTraders: {},
      constructions: [],
      constructionMovements: 0,
      storyNodePlacements: {},
      completedStoryNodes: [],
      analyzedHexes: [],
      settlementTraders: {},
      discoveredSettlements: [],
      lastSettlementPosition: null,
      homePosition: { q: 0, r: 0 }
    },

    blueprints: [],

    memories: [],

    encyclopedia: [],

    dialogue: {
      completedScenes: [],
      choiceHistory: {}
    },

    run: {
      isActive: true,
      runNumber: 1,
      hasShownBattleTip: false
    },

    tutorial: {
      shownNotifications: []
    },

    battle: {
      inProgress: false,
      resources: {
        gold: 0,
        mana: 0
      },
      deployedCards: [],
      cardsInHand: []
    },

    resurrection: {
      medicPosition: null,
      depositedSpirit: 0
    },

    scientist: {
      totalDeposited: 0
    },

    traits: {
      aggressive: 0,
      empathetic: 0,
      analytical: 0,
      cautious: 0
    },

    relations: {
      marious: 0,
      ritchin: 0,
      mant: 0,
      mei: 0,
      andrei: 0
    },

    failedWhiteChecks: {},
    redCheckResults: {},
    rewardClaims: {},

    // Per-NPC phone-call schedules, keyed by character id (lazily filled by NpcCallSystem)
    npcCalls: {}
  };
}
